var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading)?[_c('b-avatar',{attrs:{"size":"35px","variant":"primary","badge-variant":_vm.userInfo.variant,"text":_vm.userInfo.userInitials,"src":_vm.userInfo.avatar}})]:_c('b-skeleton',{attrs:{"type":"avatar"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }